<template>
  <nav v-if="shouldShowPagination" aria-label="Page navigation example">
    <ul class="pagination">
      <span class="page-item" :class="{ disabled: !canGoToPreviousPage }">
        <a class="page-link" href="#" @click="navigate($event, source.page - 1)">Anterior</a>
      </span>

      <span class="page-item" v-for="(page, index) in pages" :key="index" track-by="$index" :class="{ active: source.page == page }">
        <span class="page-link" v-if="page == '...'">{{ page }}</span>
        <a class="page-link" href="#" v-if="page != '...'" @click="navigate($event, page)">{{ page }}</a>
      </span>

      <span class="page-item" :class="{ disabled: !canGoToNextPage }">
        <a class="page-link" href="#" @click="nextPrev($event, source.page)">Próxima</a>
      </span>
    </ul>
  </nav>
</template>
<script>
export default {
  props: ['source', 'disabled'],

  data() {
    return {
      pages: [],
      index: null
    }
  },

  computed: {
    shouldShowPagination() {
      return this.source && this.source.records > 0
    },

    canGoToNextPage() {
      // Só pode ir para próxima se:
      // 1. Há mais de uma página
      // 2. Não está na última página
      // 3. Há registros para mostrar
      return this.source.pages > 1 && this.source.page < this.source.pages && this.source.records > 0
    },

    canGoToPreviousPage() {
      // Só pode ir para anterior se:
      // 1. Há mais de uma página
      // 2. Não está na primeira página
      // 3. Há registros para mostrar
      return this.source.pages > 1 && this.source.page > 1 && this.source.records > 0
    }
  },

  watch: {
    source() {
      this.pages = this.generatePagesArray(this.source.page, this.source.records, this.source.rowsPerPage, this.source.paginationRange)
    }
  },

  methods: {
    generatePagesArray: function (currentPage, collectionLength, rowsPerPage, paginationRange) {
      var pages = []

      // Se não há registros, retornar array vazio
      if (collectionLength <= 0) {
        return pages
      }

      var totalPages = Math.ceil(collectionLength / rowsPerPage)
      var halfWay = Math.ceil(paginationRange / 2)
      var position

      if (currentPage <= halfWay) {
        position = 'start'
      } else if (totalPages - halfWay < currentPage) {
        position = 'end'
      } else {
        position = 'middle'
      }

      var ellipsesNeeded = paginationRange < totalPages
      var i = 1
      while (i <= totalPages && i <= paginationRange) {
        var pageNumber = this.calculatePageNumber(i, currentPage, paginationRange, totalPages)
        var openingEllipsesNeeded = i === 2 && (position === 'middle' || position === 'end')
        var closingEllipsesNeeded = i === paginationRange - 1 && (position === 'middle' || position === 'start')
        if (ellipsesNeeded && (openingEllipsesNeeded || closingEllipsesNeeded)) {
          pages.push('...')
        } else {
          pages.push(pageNumber)
        }
        i++
      }
      return pages
    },

    calculatePageNumber: function (i, currentPage, paginationRange, totalPages) {
      var halfWay = Math.ceil(paginationRange / 2)
      if (i === paginationRange) {
        return totalPages
      } else if (i === 1) {
        return i
      } else if (paginationRange < totalPages) {
        if (totalPages - halfWay < currentPage) {
          return totalPages - paginationRange + i
        } else if (halfWay < currentPage) {
          return currentPage - halfWay + i
        } else {
          return i
        }
      } else {
        return i
      }
    },

    nextPrev(ev, page) {
      // Verificar se pode navegar para próxima página
      if (!this.canGoToNextPage) {
        return
      }

      const nextPage = parseInt(page) + 1
      const totalPages = parseInt(this.source.pages)

      // Verificar se a próxima página é válida
      if (nextPage > totalPages || nextPage <= 0) {
        return
      }

      this.navigate(ev, nextPage)
    },

    navigate(ev, page) {
      ev.preventDefault()

      // Não permitir navegação se não há registros
      if (this.source.records <= 0) {
        return
      }

      this.$emit('navigate', page)
    }
  }
}
</script>
